import HttpClient from '../../../infrastructure/http/httpClient';
import { map, concatAll, toArray } from "rxjs/operators";
import { of } from "rxjs";
import GeoSuggestion from "../../../entities/GeoSuggestion";
import GeoLocation from "../../../entities/GeoLocation";
import appConfig from '../../../config/app';


export default {
    getSuggestions(query) {
        return HttpClient.get(appConfig.geoApiUrl + `/locations?query=${query}`, true, true)
            .pipe(
                concatAll(suggestions => of(suggestions)),
                map(suggestion => {
                    return new GeoSuggestion(
                        suggestion.id,
                        suggestion.name
                    )
                }),
                toArray()
            );
    },

    getLocation(id) {
        return HttpClient.get(appConfig.geoApiUrl + `/locations/${id}`, true, true)
            .pipe(
                map(location => {
                    return new GeoLocation(
                        location.id,
                        location.name,
                        location.latitude,
                        location.longitude
                    )
                })
            );
    }
}



// WEBPACK FOOTER //
// ./port/adapter/GeoService/index.js